/* eslint-disable @typescript-eslint/no-explicit-any */
import { SupabaseClient } from '@supabase/supabase-js';

import { Database, withLogs } from '@core';

import { ResponseWithCount } from '../responses';

import { mapSwing, Swing, SWING_QUERY } from './swing';

export type ElvaSwing = Swing;

type FetchElvaSwingOptions = { userId: string; from: number; to: number; nameFilter?: string };

const mapElvaSwings = (data: any): ElvaSwing[] => {
    return data.map(mapSwing);
};

export const fetchElvaSwings = withLogs(
    async (
        supabase: SupabaseClient<Database>,
        { userId, from, to, nameFilter }: FetchElvaSwingOptions,
    ): Promise<ResponseWithCount<ElvaSwing[]>> => {
        let query = supabase
            .from('swings')
            .select(
                SWING_QUERY,
                // Built-in supabase row count
                { count: 'exact' },
            )
            .order('created_at', { ascending: false })
            .eq('deleted', false)
            .eq('elva_swing', true)
            // Supabase uses inclusive range [from, to] instead of the usual [from, to)
            // So .range(0, 9) will return 10 rows (including index 9)
            // this is why we need to subtract -1 from to.
            .range(from, to - 1);

        if (nameFilter) {
            query = query.ilike('name', `%${nameFilter}%`);
        }

        const { data: swings, error, count } = await query;

        if (error) {
            throw error;
        }
        const data = mapElvaSwings(swings);
        return { data, count };
    },
    'fetchElvaSwings',
);
